import type * as SchemaTypes from '../../../apolloClient.types';

import type { GroupItemDataFragment } from '../CreateGroup/CreateGroup.api';
import { gql } from '@apollo/client';
import { GroupItemDataFragmentDoc } from '../CreateGroup/CreateGroup.api';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateGroupMutationVariables = SchemaTypes.Exact<{
  id: SchemaTypes.Scalars['ObjectID']['input'];
  input: SchemaTypes.UpdateGroupInput;
}>;


export type UpdateGroupMutation = (
  { __typename: 'Mutation' }
  & { updateGroup: (
    { __typename: 'ErrorResponse' }
    & { fields?: SchemaTypes.Maybe<Array<(
      { __typename: 'ErrorOnField' }
      & Pick<SchemaTypes.ErrorOnField, 'field' | 'message'>
    )>> }
  ) | (
    { __typename: 'UpdateGroupSuccessfulResponse' }
    & { result: (
      { __typename: 'Group' }
      & GroupItemDataFragment
    ) }
  ) }
);


export const UpdateGroupDocument = /*#__PURE__*/ gql`
    mutation UpdateGroup($id: ObjectID!, $input: UpdateGroupInput!) {
  updateGroup(id: $id, input: $input) {
    __typename
    ... on UpdateGroupSuccessfulResponse {
      result {
        ...GroupItemData
      }
    }
    ... on ErrorResponse {
      fields {
        field
        message
      }
    }
  }
}
    ${GroupItemDataFragmentDoc}`;
export type UpdateGroupMutationFn = Apollo.MutationFunction<UpdateGroupMutation, UpdateGroupMutationVariables>;

/**
 * __useUpdateGroupMutation__
 *
 * To run a mutation, you first call `useUpdateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGroupMutation, { data, loading, error }] = useUpdateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateGroupMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGroupMutation, UpdateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGroupMutation, UpdateGroupMutationVariables>(UpdateGroupDocument, options);
      }
export type UpdateGroupMutationHookResult = ReturnType<typeof useUpdateGroupMutation>;
export type UpdateGroupMutationResult = Apollo.MutationResult<UpdateGroupMutation>;
export type UpdateGroupMutationOptions = Apollo.BaseMutationOptions<UpdateGroupMutation, UpdateGroupMutationVariables>;